import React from "react";
import _ from "lodash";

import { NATURE_MERCH_ID, GSK_ID, sources, roles } from "../../configs/constants";
import AuthRender from "../../containers/AuthRender";
import ModifyKpiResponses from "./ModifyKpiResponses";

export const get = (path, object, defaultValue = null) =>
  path.reduce((xs, x) => (xs && xs.hasOwnProperty(x) ? xs[x] : defaultValue), object);

const formats = {
  BOOLEAN: "Boolean",
  RADIO: "radio",
  CHECKBOX: "checkbox",
  equals: (s1 = "", s2 = "") => {
    if (s1 === null || s2 === null) return false;
    return s1.toLowerCase() === s2.toLowerCase();
  }
};

export const computeDataTable = ({ data, itemListWithDuplication, source, path, visitId }) => {
  let itemList = itemListWithDuplication;
  if (source === "family") {
    itemList = itemListWithDuplication.filter(
      (family, index, self) => index === self.findIndex(f => f.family_id === family.family_id)
    );
  }
  let shouldDisplayTable = false;
  let datas = data
    .filter(kpi => Array.isArray(kpi.response))
    .map(kpi => {
      return kpi.response.map(response => ({
        ...response,
        format: kpi.format,
        kpiId: kpi.id,
        question: kpi.question || kpi.description,
        values: Array.isArray(kpi.values) ? kpi.values.filter(elem => elem.indexOf("@") === -1) : []
      }));
    })
    .flat();

  const table = itemList.map(item => {
    let responsesWithDuplicate = datas.filter(data => item.id == data[source]);
    let responses = responsesWithDuplicate
      .filter((v, i, a) => a.findIndex(t => t.question === v.question) === i)
      .map(elem => {
        if (elem.response != undefined) {
          shouldDisplayTable = true;
        }
        if (formats.equals(elem.format, formats.BOOLEAN)) {
          return { [elem.question]: elem.response ? "Oui" : "Non" };
        } else if (formats.equals(elem.format, formats.RADIO)) {
          return { [elem.question]: elem.response !== null ? elem.values[elem.response] : "-" };
        } else if (formats.equals(formats.CHECKBOX, elem.format)) {
          return {
            [elem.question]: Array.isArray(elem.response)
              ? elem.response.map(item => elem.values[item]).join(", ")
              : "-"
          };
        } else {
          return {
            [elem.question]: {
              formatedResponse: elem.response ? elem.response : "-",
              kpiFormat: elem.format,
              kpiId: elem.kpiId,
              response: elem.response,
              question: elem.question
            }
          };
        }
      })
      .reduce((acc, cur) => ({ ...acc, ...cur }), {});

    return { itemId: item.id, visitId, label: item.label, ...responses, path };
  });
  if (shouldDisplayTable === false) return [];

  return table;
};

export const computeGskRecadrageTable = ({ data }) => {
  let datas = data
    .filter(kpi => Array.isArray(kpi.response))
    .map(kpi => {
      return kpi.response.map(response => ({
        ...response,
        format: kpi.format,
        kpiId: kpi.id,
        question: kpi.question || kpi.description
      }));
    })
    .flat();
  const table = datas.map(item => ({
    [item.question]: item.response ? "Oui" : "Non",
    label: `${item.family_label} - ${item.brand_label}`,
    itemId: `${item.family_label} - ${item.brand_label}`
  }));

  return table;
};

export const computeColumns = (name, data) => {
  const questionsList = [...new Set(data.map(kpi => kpi.question || kpi.description))];

  const columnsQuestion = questionsList.map((column, i) => ({
    title: column,
    dataIndex: column || "-",
    render: (response, record, index) => {
      return (
        <div key={index}>
          <span>{typeof response === "object" ? response.formatedResponse || response.response : response}</span>
          {typeof response === "object" && (
            <AuthRender minRole={roles.ADMIN}>{<ModifyKpiResponses record={record} question={column} />}</AuthRender>
          )}
        </div>
      );
    }
  }));
  const columns = [{ title: name, dataIndex: "label" }].concat(columnsQuestion);

  return columns;
};

export const extractStatementsFromVisits = (visit = {}) => {
  const locationsData = [];
  const familiesList = [];
  const categoriesList = [];
  const brandsList = [];

  for (let i = 0; i < visit.survey.length; i++) {
    const survey = visit.survey[i] || {};

    const locationTypeId = visit.survey[i] ? visit.survey[i].locationTypeId : null;

    for (let j = 0; j < survey.locations.length; j++) {
      const location = survey.locations[j] || {};
      const locationId = survey.locations[j] ? survey.locations[j].locationId : null;

      for (let k = 0; k < location.statements.length; k++) {
        const statement = location.statements[k] || {};

        const kpis = statement.kpis || [];
        const kpisSourceLocationType = kpis.filter(
          kpi => kpi.source && (kpi.source.toUpperCase() === "LOCATIONTYPE" || kpi.source.toUpperCase() === "PDC")
        );
        const productsEANAndFamilyList = listProductsWithEan(visit, locationId, locationTypeId);
        const statementData = extractFamiliesFromStatement(statement, productsEANAndFamilyList);
        const vendorKpi = kpis.find(kpi => sources.equals(kpi.source, sources.VENDOR)) || {};
        const moduleData = extractModuleDataFromStatement(statement);
        locationsData.push({
          locationLabel: location.label || "",
          statementLabel: statement.description || statement.label || "",
          data: statementData,
          medias: statement.medias,
          question: statement.question || "",
          locationTypeResponse: kpisSourceLocationType,
          locationId,
          locationTypeId,
          moduleData,
          vendors: vendorKpi.response,
          brandsData: extractDataFromStatement(statement, "brand"),
          categoriesData: extractDataFromStatement(statement, "category"),
          familiesData: extractDataFromStatement(statement, "family"),
          statementId: statement.id
        });
      }
      for (let c = 0; c < location.categories.length; c++) {
        const category = location.categories[c];
        if (categoriesList.findIndex(cat => cat.id === category.categoryId) === -1) {
          categoriesList.push({ id: category.categoryId, label: category.label });
        }
        const families = category.families || [];
        for (let f = 0; f < families.length; f++) {
          const family = families[f];
          if (familiesList.findIndex(fam => fam.familyId === family.familyId) === -1) {
            familiesList.push({
              family_id: family.familyId,
              family_label: family.label,
              id: family.familyId,
              label: family.label
            });
            const brands = family.brands || [];
            for (let f = 0; f < brands.length; f++) {
              const brand = brands[f];
              if (brandsList.findIndex(br => br.id === brand.brandId) === -1) {
                brandsList.push({
                  id: brand.brandId,
                  label: brand.label
                });
              }
            }
          }
        }
      }
    }
  }

  return { locationsData, familiesList, brandsList, categoriesList };
};

const extractModuleDataFromStatement = statement => {
  const kpis = statement.kpis.filter(kpi => kpi.nature_id === NATURE_MERCH_ID); //keep merch
  return kpis;
};
const removeDuplicateResponse = kpi => {
  if (sources.equals(kpi.source, sources.FAMILY)) {
    return kpi.response.filter((response, index, self) => index === self.findIndex(r => r.family === response.family));
  } else return kpi.response;
};
const extractDataFromStatement = (statement, _source = "") => {
  const source = _source.toLowerCase();
  return statement.kpis
    .filter(kpi => {
      if (source === "brand") {
        return kpi.source.toLowerCase() === "brand" || kpi.source.toLowerCase() === "brandsofcategory";
      }

      return kpi.source.toLowerCase() === source;
    })
    .map(kpi => {
      const responsesOfKpi = removeDuplicateResponse(kpi);
      kpi.response = [...responsesOfKpi];
      return kpi;
    });
};

export const extractFamiliesFromStatement = (statement, listProductsWithFamiliesId) => {
  const familiesIdList = [...new Set(listProductsWithFamiliesId.map(product => product.familyId))];

  return familiesIdList.map(familyId => {
    const listProductsEanOfFamily = listProductsWithFamiliesId
      .filter(product => product.familyId === familyId)
      .map(product => product.ean);
    const kpisSourceProductsList = statement.kpis.filter(kpi => kpi.source && kpi.source.toUpperCase() === "PRODUCT");
    const kpisSourceFamiliesList = statement.kpis.filter(kpi => kpi.source && kpi.source.toUpperCase() === "FAMILY");
    const labelsOfKpisProducts = [
      ...new Set(
        statement.kpis.filter(kpi => kpi.source && kpi.source.toUpperCase() === "PRODUCT").map(kpi => kpi.long_label)
      )
    ];

    return {
      familyId,
      responseProducts: extractResponsesProductsOfFamily(
        kpisSourceProductsList,
        listProductsEanOfFamily,
        labelsOfKpisProducts
      ),
      responseFamily: extractResponsesFamilyOfFamily(kpisSourceFamiliesList, familyId),
      labelsOfKpisProducts
    };
  });
};

export const extractResponsesProductsOfFamily = (kpis, EANProductsList) => {
  const responseProductsByFamily = [];

  for (let i = 0; i < kpis.length; i++) {
    const kpi = kpis[i] || {};
    const kpiValues = Array.isArray(kpi.values) ? kpi.values.filter(elem => elem.indexOf("@") === -1) : [];
    kpi.response = kpi.response || [];
    for (let j = 0; j < kpi.response.length; j++) {
      const responseElement = kpi.response[j];
      if (!responseElement || EANProductsList.indexOf(responseElement.product) === -1) continue;
      const productIndex = _.findIndex(responseProductsByFamily, {
        product: responseElement.product
      });
      let response = responseElement.response;

      // if (!response) continue;
      if (formats.equals(kpi.format, formats.BOOLEAN)) {
        response = response === "true" || response === true ? "Oui" : "Non";
      } else if (formats.equals(kpi.format, formats.RADIO)) {
        response = response !== null ? kpiValues[response] : "-";
      } else if (formats.equals(formats.CHECKBOX, kpi.format) && Array.isArray(response)) {
        response = response.map(item => kpiValues[item]).join(", ");
      }

      if (productIndex === -1) {
        responseProductsByFamily.push({
          product: responseElement.product,
          product_label: responseElement.product_label,
          [kpi.long_label]: response === null ? "-" : response
        });
      } else {
        responseProductsByFamily[productIndex][kpi.long_label] = response === null ? "-" : response;
      }
    }
  }

  return responseProductsByFamily;
};

export const extractResponsesFamilyOfFamily = (kpisSourceFamiliesList, familyId) => {
  const responseFamily = [];
  for (let i = 0; i < kpisSourceFamiliesList.length; i++) {
    const kpi = kpisSourceFamiliesList[i];
    kpi.response = kpi.response || [];
    for (let r = 0; r < kpi.response.length; r++) {
      const response = kpi.response[r];

      if (response.family === familyId) {
        responseFamily.push({ ...response, question: kpi.question });
        break;
      }
    }
  }
  return responseFamily;
};

export const listProductsWithEan = (visit, locationId, locationTypeId) => {
  const visitInfos = visit.survey;
  const locationTypeObject = visitInfos.find(location => location.locationTypeId === locationTypeId);

  if (!locationTypeObject || !locationTypeObject.locations) return [];

  const locationObject = locationTypeObject.locations.find(location => location.locationId === locationId);
  if (!locationObject) return [];

  const categoriesArray = locationObject.categories;
  if (!categoriesArray) return [];

  return categoriesArray
    .map(categorie =>
      categorie.families.map(family =>
        family.brands.map(brand =>
          brand.products.map(product => {
            return { ean: product.ean, familyId: product.familyId };
          })
        )
      )
    )
    .reduce((a, b) => a.concat(b), [])
    .reduce((a, b) => a.concat(b), [])
    .reduce((a, b) => a.concat(b), []);
};

export const getProductsInfos = (ean, visit, locationId, locationTypeId) => {
  const visitInfos = visit.survey;

  const locationTypeObject = visitInfos.find(location => location.locationTypeId === locationTypeId);

  if (!locationTypeObject || !locationTypeObject.locations) return null;

  const locationObject = locationTypeObject.locations.find(location => location.locationId === locationId);
  if (!locationObject) return null;

  const categoriesArray = locationObject.categories;
  if (!categoriesArray) return null;

  const product = lookForProduct(categoriesArray, ean);
  return product;
};

const lookForProduct = (categoriesArray, ean) => {
  return categoriesArray.map(categorie => lookForProductInCategory(categorie.families, ean)).find(product => product);
};

const lookForProductInCategory = (familiesArray, ean) => {
  return familiesArray.map(family => lookForProductInFamily(family.brands, ean)).find(product => product);
};
const lookForProductInFamily = (brandsArray, ean) => {
  return brandsArray.map(brand => brand.products.find(product => product.ean === ean)).find(product => product);
};

export const getModuleInfos = (
  module_id,
  module_dep_id,
  module_type_id,
  module_item_id,
  visit,
  locationId,
  locationTypeId,
  statementId
) => {
  const visitInfos = visit.survey;

  const locationTypeObject = visitInfos.find(location => location.locationTypeId === locationTypeId);

  if (!locationTypeObject || !locationTypeObject.locations) return null;

  const locationObject = locationTypeObject.locations.find(location => location.locationId === locationId);
  if (!locationObject) return null;

  const statementsArray = locationObject.statements;
  if (!statementsArray) return null;

  const statement = statementsArray.find(statement => statement.id === statementId);
  let module_info = {};
  for (let i = 0; i < statement.kpis.length; i++) {
    const kpi = statement.kpis[i];

    if (kpi.response && kpi.nature_id === NATURE_MERCH_ID && kpi.modules) {
      if (kpi.modules.id !== module_id) continue;
      module_info["module_label"] = kpi.modules.label;

      const module_deps = kpi.modules.dependencies;

      for (let j = 0; j < module_deps.values.length; j++) {
        const module_dep = module_deps.values[j];
        if (module_dep.id !== module_dep_id) continue;
        module_info["module_dep_label"] = module_dep.label;

        const module_types = module_dep.dependencies;
        for (let k = 0; k < module_types.values.length; k++) {
          const module_type = module_types.values[k];
          if (module_type_id !== module_type.id) continue;
          module_info["module_type_label"] = module_type.label;
          const module_items = module_type.dependencies;
          if (Array.isArray(module_items.values)) {
            for (let l = 0; l < module_items.values.length; l++) {
              const module_item = module_items.values[l];
              if (module_item.id !== module_item_id) continue;
              module_info["module_item_label"] = module_item.label;
              return module_info;
            }
          }
        }
      }
    }
  }

  return null;
};

export const addColorPropertyToProduct = (product, clientId) => {
  let productStyles = {};
  if (clientId === GSK_ID) {
    // O = Bleu
    // O;N = Vert
    // C - C;N = Gris
    // S = Rouge
    const propertiesArray = Array.isArray(product.currentProperties) ? product.currentProperties : [];

    propertiesArray.indexOf("O") > -1
      ? (productStyles = {
          ...productStyles,
          fontWeight: "bold",
          color: "#018EE4"
        })
      : null;
    propertiesArray.indexOf("O") > -1 && propertiesArray.indexOf("N") > -1
      ? (productStyles = {
          ...productStyles,
          color: "green"
        })
      : null;
    propertiesArray.indexOf("C") > -1 || (propertiesArray.indexOf("C") > -1 && propertiesArray.indexOf("N") > -1)
      ? (productStyles = {
          ...productStyles,
          color: "grey"
        })
      : null;
    propertiesArray.indexOf("S") > -1
      ? (productStyles = {
          ...productStyles,
          color: "#b70012"
        })
      : null;
  } else {
    product.currentProperties.map((property, p) => {
      property === "O"
        ? (productStyles = {
            ...productStyles,
            fontWeight: "bold",
            color: "black"
          })
        : null;
      property === "C"
        ? (productStyles = {
            ...productStyles,
            color: "grey"
          })
        : null;
      property === "N"
        ? (productStyles = {
            ...productStyles,
            color: "green"
          })
        : null;
      property === "S"
        ? (productStyles = {
            ...productStyles,
            color: "#b70012"
          })
        : null;
      property === "B"
        ? (productStyles = {
            ...productStyles,
            color: "#018EE4"
          })
        : null;
    });
  }
  return productStyles;
};

export const getKpiInfos = ({ visit = {}, path = {}, question = "" }) => {
  const { locationTypeId, locationId, statementId } = path;
  const survey = visit.survey || [];
  const locationType = survey.find(lT => lT.locationTypeId === locationTypeId) || {};
  const locations = locationType.locations || [];
  const location = locations.find(l => l.locationId === locationId) || {};
  const statements = location.statements || [];
  const statement = statements.find(s => s.id === statementId) || {};

  const kpis = statement.kpis || [];
  const kpi = kpis.find(k => k.long_label === question) || {};

  return { kpiId: kpi.id, kpiFormat: kpi.format };
};



// WEBPACK FOOTER //
// src/components/visit/Preview.utils.js